import { lazy, ReactNode } from 'react'

const CbUnicoStartPage = lazy(() => import('@pages/cbu/cb-unico-start-page'))

export const makeCbUnicoStartPage = (): ReactNode => {
  return <CbUnicoStartPage />
}
